import { render, staticRenderFns } from "./IframePage.vue?vue&type=template&id=884bf870&scoped=true"
import script from "./IframePage.vue?vue&type=script&lang=js"
export * from "./IframePage.vue?vue&type=script&lang=js"
import style0 from "./IframePage.vue?vue&type=style&index=0&id=884bf870&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884bf870",
  null
  
)

export default component.exports